export default __webpack_public_path__ + "8dd8bab2f793995a5d1bb9dfc8825252.png";